import { MediaItem } from '@/types/media.type'

export enum PrivilegeType {
  ALL = 'ALL', // ทั้งหมด
  ITEM = 'ITEM', // สินค้า
  COUPON = 'COUPON', // คูปอง
}

export type PrivilegeCode = {
  id: string
  privilegeId: string
  code: string
  isUsed: boolean
  createdAt: Date
  updatedAt: Date
}

export type Privilege = {
  id: string
  name: string
  type: PrivilegeType
  imageHeaderUrl?: string
  mediaUrls?: MediaItem[]
  description?: string
  isEnable: boolean
  startDate: Date
  endDate: Date
  expiredDate?: Date
  totalQuantity: number
  claimedQuantity: number
  limitPerUser: number
  createdBy: string
  createdAt: Date
  updatedAt: Date

  redeemConditions: RedeemCondition[]
  privilegeCodes: PrivilegeCode[]
}

export interface PrivilegeFilters {
  page: number
  limit: number
  search: string
  type: PrivilegeType
  isEnable?: boolean
  orderBy: string
}

export enum RedeemConditionType {
  // ALL = 'ALL', // ทั้งหมด
  // CASH = 'CASH', // จ่ายด้วยเงิน
  TOKEN = 'TOKEN', // จ่ายด้วย token
}

export type RedeemCondition = {
  id: string
  privilegeId: string
  type: RedeemConditionType
  amount: number
  currency: string
  tokenId?: string
  description?: string
  createdAt: Date
  updatedAt: Date
}

export interface CreatePrivilegePayload {
  name: string
  type: PrivilegeType
  imageHeaderUrl?: string
  mediaUrls?: MediaItem[]
  description?: string
  isEnable: boolean
  startDate: string
  endDate: string
  expiredDate?: string
  totalQuantity: number
  limitPerUser: number
  redeemConditions?: {
    type: RedeemConditionType
    amount: number
    currency: string
    tokenId?: string
    description?: string
  }[]
  privilegeCodes?: string[]
}
